import React from 'react';
import { formatCurrency } from '../../../../utils/formatting';
import type { CreditCardDetailsProps } from '../types/credit-card.types';

const CreditCardDetails: React.FC<CreditCardDetailsProps> = ({ orderId, totalAmount, paymentMethod }) => {
  return (
    <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-6 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <h3 className="text-lg font-semibold text-text-primary dark:text-gray-100 mb-2">
            Detalhes do Pedido
          </h3>
          <div className="space-y-2 text-sm text-text-secondary dark:text-gray-300">
            <p><strong>Número do Pedido:</strong> {orderId}</p>
            <p><strong>Valor Total:</strong> {formatCurrency(totalAmount)}</p>
            <p><strong>Forma de Pagamento:</strong> {paymentMethod}</p>
          </div>
        </div>
        
        <div>
          <h3 className="text-lg font-semibold text-text-primary dark:text-gray-100 mb-2">
            Próximos Passos
          </h3>
          <div className="space-y-2 text-sm text-text-secondary dark:text-gray-300">
            <p>✅ Pagamento processado com sucesso</p>
            <p>📧 E-mail de confirmação enviado</p>
            <p>📦 Pedido será processado em breve</p>
            <p>🚚 Acompanhe o status do envio</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditCardDetails; 